<template>
  <v-data-table
    class="elevation-0"
    :headers="headers"
    :items="list"
    hide-default-footer
    disable-pagination
  >
    <template v-slot:[`item.planColHexaCd`]="{ item }">
      <v-chip :color="item.planColHexaCd" small></v-chip>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="onEdit(item)">mdi-pencil</v-icon>
      <v-icon small @click="onRemove(item)">mdi-delete</v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      headers: [
        {
          text: "일정구분색상",
          value: "planColHexaCd",
          width: "10%",
          align: "center",
          sortable: false,
        },
        { text: "일정구분명", value: "planTyNm", width: "20%" },
        { text: "비고", value: "note", width: "62%", sortable: false },
        {
          text: "",
          value: "actions",
          width: "8%",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      list: state => state.settingPlanTy.lists,
    }),
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["FETCH_PLANTYPES", "FETCH_PLANTYPE", "DEL_PLANTYPE"]),
    async fetchData() {
      try {
        await this.FETCH_PLANTYPES();
      } catch (error) {
        console.log(error);
      }
    },
    onEdit(item) {
      this.$router.push(`${this.$route.path}/write/${item.planTyNo}`);
      this.FETCH_PLANTYPE(item.planTyNo);
    },
    async onRemove(item) {
      try {
        await this.DEL_PLANTYPE(item.planTyNo);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
